// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var ReactRender = require("../../../reason/utils/ReactRender.bs.js");
var Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Form__TextAreaField = require("../../../uikit/reason/atoms/Form/Form__TextAreaField.bs.js");
var InlineWarning__Jsx3 = require("../../../uikit/reason/atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var WithdrawForSalePropertyDialogMutation_graphql = require("../../../__generated__/WithdrawForSalePropertyDialogMutation_graphql.bs.js");

var convertVariables = WithdrawForSalePropertyDialogMutation_graphql.Internal.convertVariables;

var convertResponse = WithdrawForSalePropertyDialogMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = WithdrawForSalePropertyDialogMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, WithdrawForSalePropertyDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use = RescriptRelay_Mutation.useMutation(convertVariables, WithdrawForSalePropertyDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

var WithdrawForSalePropertyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function WithdrawForSalePropertyDialog(props) {
  var close = props.close;
  var propertyId = props.propertyId;
  var match = use();
  var mutate = match[0];
  var match$1 = React.useState(function () {
        return "";
      });
  var setComment = match$1[1];
  var comment = match$1[0];
  var match$2 = React.useState(function () {
        return "Idle";
      });
  var setSubmissionStatus = match$2[1];
  var submissionStatus = match$2[0];
  var resetForm = function () {
    setSubmissionStatus(function (param) {
          return "Idle";
        });
    setComment(function (param) {
          return "";
        });
  };
  var handleWithdrawingSuccess = function () {
    close();
    resetForm();
  };
  return JsxRuntime.jsx(DialogV5.make, {
              title: "Withdraw property",
              isOpen: props.isOpen,
              ariaLabel: "Withdraw property",
              onDismiss: close,
              size: "Large",
              children: JsxRuntime.jsx("form", {
                    children: JsxRuntime.jsxs(ViewStack.make, {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: "The property will no longer be active for new matches on TAN. The new TAN status and your comments will show to TAN members on existing matches."
                                }),
                            JsxRuntime.jsx(Form__TextAreaField.make, {
                                  labelText: "Comments",
                                  optionalText: "optional",
                                  onChange: (function (evt) {
                                      var value = evt.target.value;
                                      setComment(value);
                                    }),
                                  value: comment
                                }),
                            ReactRender.ifTrue(JsxRuntime.jsx(InlineWarning__Jsx3.make, {
                                      children: "There was a problem withdrawing the property. Please try again."
                                    }), submissionStatus === "SubmissionError"),
                            JsxRuntime.jsxs(ViewStack.make, {
                                  mt: "lg",
                                  space: "sm",
                                  justifyContent: "flexEnd",
                                  flexDirection: "row",
                                  children: [
                                    JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                                          onClick: (function (param) {
                                              close();
                                            }),
                                          disabled: submissionStatus === "Loading",
                                          size: "medium",
                                          _type: "button",
                                          children: "Cancel"
                                        }),
                                    JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                          disabled: submissionStatus === "Loading",
                                          children: "Withdraw"
                                        })
                                  ]
                                })
                          ]
                        }),
                    onSubmit: (function ($$event) {
                        $$event.preventDefault();
                        setSubmissionStatus(function (param) {
                              return "Loading";
                            });
                        mutate({
                              input: {
                                comments: Form__Helpers.opt_of_string(comment),
                                id: propertyId
                              }
                            }, undefined, undefined, undefined, (function (param, param$1) {
                                var withdrawForSaleProperty = param.withdrawForSaleProperty;
                                if (withdrawForSaleProperty !== undefined) {
                                  if (withdrawForSaleProperty.__typename === "ForSalePropertyWithdrawn") {
                                    return handleWithdrawingSuccess();
                                  } else {
                                    return setSubmissionStatus(function (param) {
                                                return "SubmissionError";
                                              });
                                  }
                                } else {
                                  return setSubmissionStatus(function (param) {
                                              return "SubmissionError";
                                            });
                                }
                              }), (function (param) {
                                setSubmissionStatus(function (param) {
                                      return "SubmissionError";
                                    });
                              }), undefined);
                      })
                  })
            });
}

var make = WithdrawForSalePropertyDialog;

exports.WithdrawForSalePropertyMutation = WithdrawForSalePropertyMutation;
exports.make = make;
/* commitMutation Not a pure module */
